<template>
    <div>
        <fluke-card>
            <header>
                <div class="title">Adicionar Item de Menu</div>
                <div class="description">Adicione as informações necessárias</div>
            </header>
            <main>

                <v-switch v-model="menuOptions.newWindow" label="Nova Aba" :disabled="permission.write?null:true" />

                <v-select
                    v-model="menuOptions.positions.selected"
                    :items="menuOptions.positions.options"
                    item-text="title"
                    item-value="value"
                    label="Posição"
                    required
                    class="half-form"
                    :disabled="permission.write?null:true" />

                <v-select
                    v-model="menuOptions.types.selected"
                    :items="menuOptions.types.options"
                    item-text="title"
                    item-value="value"
                    label="Tipo"
                    required
                    class="half-form"
                    :disabled="permission.write?null:true" />

                <div v-show="menuOptions.types.selected == 'page'">
                    <page-type v-model="current.page" />
                </div>
                <div v-show="menuOptions.types.selected == 'course'">
                    <course-type v-model="current.course" />
                </div>
                <div v-show="menuOptions.types.selected == 'post'">
                    <post-type v-model="current.post" />
                </div>
                <div v-show="menuOptions.types.selected == 'custom'">
                    <custom-type v-model="current.custom" />
                </div>

                <v-text-field 
                    label="Título" 
                    v-model="title" />
            </main>
            <footer>
                <fluke-button v-on:click.native="cancel" color="grey">Cancelar</fluke-button>
                <fluke-button v-on:click.native="submit">Adicionar</fluke-button>
            </footer>
        </fluke-card>
    </div>
</template>

<script>
import axios from 'axios';

import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';

import typePage from './types/page';
import typeCourse from './types/course';
import typePost from './types/post';
import typeCustom from './types/custom';

import permission from '../../mixins/permissions';

export default {
    mixins: [ permission ],
    components: {
        'fluke-card': Card,
        'fluke-button': Button,
        'page-type': typePage,
        'course-type': typeCourse,
        'post-type': typePost,
        'custom-type': typeCustom
    },
    data: function() {
        return {
            title: '',
            menuOptions: {
                positions: {
                    selected: 'top',
                    options: [
                        { title: 'Superior', value: 'top' },
                        { title: 'Inferior', value: 'bottom' }
                    ]
                },
                types: {
                    selected: 'page',
                    options: [
                        { title: 'Página', value: 'page' },
                        { title: 'Curso', value: 'course' },
                        { title: 'Blog', value: 'blog' },
                        { title: 'Post ( Blog )', value: 'post' },
                        { title: 'Personalizado', value: 'custom' }
                    ]
                },
                newWindow: false,
            },
            permission: {
                read: false,
                write: false
            },
            current: {
                page: '',
                course: '',
                blog: '/blog',
                post: '',
                custom: ''
            }
        }
    },
    created: function() {
        this.permission = this.getUserPagePermission('menu');
		if( this.permission.read == false || this.permission.write == false ) {
			this.$router.push('/');
		}
    },
    methods: {
        async submit() {
            await axios.post(
				this.$myServerAddresses.pages + 'pages/menu',
				{
                    new_window: this.menuOptions.newWindow,
                    position: this.menuOptions.positions.selected,
                    type: this.menuOptions.types.selected,
                    link: this.current[this.menuOptions.types.selected],
                    label: this.title
				},
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );

            this.$router.push({ name: 'menu' });
        },
        cancel() {
			this.$router.push({ name: 'menu' });
		}
    }
}
</script>
